import type { InsightsRange } from "@/lib/api";

const RANGES: InsightsRange[] = ["24h", "7d", "30d"];

const RANGE_LABEL: Record<InsightsRange, string> = {
  "24h": "24 horas",
  "7d": "7 dias",
  "30d": "30 dias",
};

interface InsightsRangePickerProps {
  value: InsightsRange;
  onChange: (range: InsightsRange) => void;
}

export function InsightsRangePicker({ value, onChange }: InsightsRangePickerProps) {
  return (
    <div
      className="flex rounded-lg border border-ink-700 bg-ink-900 p-0.5"
      role="group"
      aria-label="Selecionar período"
    >
      {RANGES.map((range) => {
        const active = range === value;
        return (
          <button
            key={range}
            type="button"
            onClick={() => onChange(range)}
            aria-pressed={active}
            className={`rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
              active
                ? "bg-ink-700 text-ink-100 shadow-sm"
                : "text-ink-400 hover:text-ink-200"
            }`}
          >
            {RANGE_LABEL[range]}
          </button>
        );
      })}
    </div>
  );
}
